import React ,{useRef ,useEffect ,useState}from 'react';
import SecurityService from '../security/security.service';
import moment from 'moment'

import DynamicInputList from '../software-dynamic-version-2/list-input-v-2';
import DialogInput from '../software-dynamic-version-2/popup-dialog-input-v-2';


import CompanyAdd  from './company-add'
import CompanyService from './company.service';
import AuditTable from '../audit-table/audit-table';
import './company.scss'
import securityService from '../security/security.service';
import TemplateCode from '../template-code/template-code';
import { useDispatch, useSelector } from 'react-redux';
import { setUpdateLogo } from '../../store/slices/head';



const CompanyInput = (props) => {
    // let handleCheckboxChange = (e,props)=>{
    //   console.log(e)
    //   CompanyService.delete(props.UserID).then(async (res)=>{
    //     document.getElementById(`checkbox_${props.UserID}`).checked =false
    //     await  showDialog('ALERT' ,<span class="error-success">User Actived</span>)
    //       // await getListService()
    //       })
    // }
    const dispatch = useDispatch()
   
    let columns =[
      { field: "CompanyID", headerText:'Company ID', width:'90px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "CompanyName", headerText:'Company Name', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "CompanyAddress", headerText:'Company Address', width:'200px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "CompanyTradeLicenseNo", headerText:'Trade License No', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      // { field: "CompanyLogo", headerText:'Company Logo', width:'120px', textAlign:'center', headerTextAlign:'center', other:[{
      //   template:(e)=>{
      //     console.log(e);
      //     return(
      //       <div style={{height:'150px', padding:'10px'}}>
      //       <img src={e.CompanyLogo} alt='wait...' style={{objectFit:'contain',height:'100%' ,width:'100%'}}/>
      //       </div>
      //     )
      //   }
      // }] },
      // { field: "ClientID", headerText:'Client ID', width:'100px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "RepresentedBy", headerText:'Represented By', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "ReceivableAccountTitle", headerText:'Receivable Account', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "PayableAccountTitle", headerText:'Payable Account', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "AgentAccountTitle", headerText:'Agent Account', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] }
    ];
    
        const listActionComplete = async (grid , args ,getListService ,selectedRow  ,setDataSourceState ,addUserLog,editUserLog)=>{
          console.log(args )
          console.log(getListService )
          console.log(selectedRow )
    
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        if(args.requestType == 'save'){
          let data = {
            CompanyID: securityService.getCompanyIDLoggedInUserId(),
              CompanyName: args.data.CompanyName,
              CompanyAddress: args.data.CompanyAddress,
              CompanyTradeLicenseNo: args.data.CompanyTradeLicenseNo,
              CompanyLogo: args.data.CompanyLogo,
              ClientID: args.data.ClientID,
              RepresentedBy: args.data.RepresentedBy,
              ReceivableAccountCode: args.data.ReceivableAccountCode,
              AccountIDReceivable: args.data.AccountIDReceivable,
              PayableAccountCode: args.data.PayableAccountCode,
              AccountIDPayable: args.data.AccountIDPayable
          }

      
    
          console.log(data)
        if(args.action == 'add'){
          CompanyService.insert(data).then(async (res)=>{
            await getListService()
            // inputName ,tableName,tableID,values
            // addUserLog('Company'  ,'Company',selectedRow,{
            //   UserName:args.data.UserName,
            //   UserFullName:args.data.UserFullName,
            // })
          })
        }
        if(args.action == 'edit'){
          CompanyService.update(data).then((res)=>{
            getListService()
            dispatch(setUpdateLogo(true))
            // tableName,tableIDValue,selectedRows,values
            // editUserLog('Company',args.data.UserID,'UserID',{
            //   UserName:args.data.UserName,
            //   UserFullName:args.data.UserFullName,
            // })
          })
        }
        }
        
      }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = false
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = true
    let  allowDataBound = true
    let  allowGridSum = false
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
        // @default Company${typeMode} 
        let ListSecurity='Company'
        let AddSecurity='Company'
        let EditSecurity='Company'
        let DeleteSecurity='Company'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      // let toolbarOptions ='All';
      let toolbarOptions =['Edit','PDFExport','ExcelExport','Search','ColumnChooser'].filter(Boolean);
          

        //   const dialogRef = useRef(null);
        //   const showDialog = (header,title,actions =['OK']) => {
        //     return new Promise((resolve) => {
        //     // Destroy existing dialog if any
        //     if (dialogRef.current) {
        //       dialogRef.current.destroy();
        //     }
        //     const okButtons = actions.map((action) => ({
        //       buttonModel: {
        //         content: action,
        //         cssClass: 'e-flat',
        //         isPrimary: action === 'OK',
        //       },
        //       click: (e) => {
        //         hideDialog();
        //         resolve(action);
        //       },
        //     }));
        //     // Create a new dialog instance
        //     dialogRef.current = new DialogInput({
        //       content: ()=>(<>{title}</>),
        //       header:header,
        //       width:'340px',
        //       showButtons: true,
        //       buttons:okButtons
        //     });
        //     // Show the dialog programmatically
        //     dialogRef.current.show();

        //   });

        //   };
        // const hideDialog = () =>{
        //   if (dialogRef.current) {
        //   }
        //   dialogRef.current.hide();
        //   dialogRef.current.destroy();
        //   dialogRef.current = null; // Clean up reference after destruction
        // }

      const toolbarClicking =  async (grid , args , selectedRow , getListService)=>{
        console.log(grid , args)
        console.log(selectedRow)
      //   if(props.Active ==  false  ){
      //      if(args.name == "rowSelected" || args.name == "rowDeselected"){
      //     if(args.target?.type ==  'checkbox'){
      //   setTimeout( async () => {
          
      //     await getListService()
      //   }, 1500);
      // }
      // }
    
      // }
      //   if(args?.item?.properties?.id == 'IsActive'){
      //     if(selectedRow == undefined){
      //   await showDialog('WARNING' ,<span class="error-tooltip">Please select a row first!</span>)
      // }else{
      //   let dialogResult  = await showDialog('Confirmation' ,<span class="error-success">Are you sure you want to delete?</span> , ['OK','CANCEL'])
      //   console.log(dialogResult)
      // if(dialogResult == 'OK'){
      //   CompanyService.delete(selectedRow.UserID).then(async (res)=>{
      //   await  showDialog('ALERT' ,<span class="error-success">RECORD(S) DELETED SUCESSFULLY</span>)
      //     await getListService()
      //       AuditTable.auditDelete('Company',selectedRow.UserID,{
      //         UserName:selectedRow.UserName,
      //         FullName:selectedRow.FullName,
      //       })
      //     })
      //   }
      //   }
      //   }
        
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'Company' ,
                    TableID:'CompanyID',
                   // Optional if Delete is Soft // TableSecurity:'CompanyDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'Company' ,TableID:'CompanyID', Optional // TableSecurity:'CompanyDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
    //  let filterColumns = [{ field: 'IsActive', value: props?.Active == false ? 'No' : 'Yes' }];
     let filterColumns = [];
      

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
      
        <DynamicInputList
        Id='Company'
        ListTitle='Company - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> CompanyService.getCompanyForList(securityService.getCompanyIDLoggedInUserId())
                        }]}
        DefaultSortedColumnName={'UserID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<CompanyAdd GridID={'Company'} CompanyID={securityService.getCompanyIDLoggedInUserId()} />
        
            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            AllowTemplate={allowTemplate}
            ToolbarOption={toolbarOptions}
            AllowGrouping={allowGrouping}
            AllowExcelExport={allowExcelExport}
            AllowPdfExport={allowPdfExport} 
            ShowColumnChooser={showColumnChooser}
            AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
            DefaultSortedColumnSort={DefaultSortedColumnSort}
            FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            GroupColumns={groupColumns} 
            // ListDelete={listDelete}
             DeleteType={deleteType} 
            GridEditSettingMode={gridEditSettingMode}
            GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            IsDialog={isDialog}

            {...props}
            ></DynamicInputList>

            );
          
          }




export default CompanyInput;
